<section class="aarni-font py-16 md:py-56 relative w-full bg-cover mt-[80px]"
         style="background: url('https://img.freepik.com/premium-photo/happy-people-with-gadgets-sit-floor-white-wall-background_474601-10075.jpg?w=1380') ; background-size: cover; ">
    <div class="container mx-auto  md:px-16">
        <p class="text-2xl py-5 p-4 mx-auto md:mx-0 font-bold text-white w-[80%] md:w-[60%] bg-[#204F48] ">
            {{ selectedBlog.title }}
        </p>
    </div>

</section>

<section class="py-16 bg-white">
    <div class="container mx-auto px-4 lg:px-16">
        <div class="flex flex-col lg:flex-row gap-4">
            <div class="w-full lg:w-8/12 h-full">
                <div class="rounded-xl shadow-lg overflow-hidden bg-white">
                    <div class="w-full h-72 overflow-hidden">
                        <img [src]="selectedBlog?.image" alt="Blog image" class="w-full h-full object-cover"/>
                    </div>
                    <div class="p-6">
                        <h3 class="text-2xl font-bold text-gray-800 mb-4">{{ selectedBlog?.title }}</h3>
                        <p class="text-gray-700 leading-relaxed text-base">
                            {{ selectedBlog?.content }}
                        </p>
                        <div [innerHTML]="selectedBlog.long_content" class="space-y-6 text-gray-700"></div>
                    </div>

                </div>

            </div>

            <div class="w-full h-full lg:w-4/12 p-4 md:px-8 space-y-3">
                <div *ngFor="let blog of otherBlogs.slice(0,2)"
                     (click)="goTo('blog-details/'+blog.slug)"
                     class="bg-white cursor-pointer  rounded-2xl shadow-md overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
                    <img [src]="blog?.image" alt="Blog image" class="w-full h-56 object-cover">

                    <div class="p-5">
                        <h2 class="text-xl font-bold text-gray-900 mb-2">{{ blog?.title }}</h2>
                        <p class="text-sm text-gray-500 mb-2">By {{ blog?.author }} | {{ blog?.date }}</p>
                        <p class="text-gray-700 text-sm">{{ blog?.content }}</p>
                    </div>
                </div>
                <div class="text-center py-5 md:py-10">
                    <button
                        class="bg-lime-500 text-white font-semibold rounded-[25px] px-10 py-3 shadow hover:bg-lime-600"
                        (click)="goTo('/blog')">View All
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

